import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemRolesActorsUsersRoute: InvariantJiraRoute = {
	name: 'global-settings-system-roles-actors-users',
	path: '/secure/project/UserRoleActorAction.jspa',
};
